<template>
	<div>
		<div v-loading="loading">
			<canvas ref="defectCanvas" :height="imgWidthNew" :width="imgWidthNew"></canvas>
		</div>

		<div class="defectInfo">
			<ul>
				<li>
					<label for>位置：</label>
					<span> {{ defect.meter | fil }}</span>
				</li>
				<li>
					<label for>检测面：</label>
					<span v-text="defect.model_side_text"></span>
				</li>
				<li>
					<label for>缺陷类型：</label>
					<span v-text="defect.type_text"></span>
				</li>
				<li>
					<label for>面积：</label>
					<span v-text="defect.area"></span>
				</li>
				<li>
					<label for>张号：</label>
					<span v-text="defect.sheet_index"></span>
				</li>
				<li>
					<label for>联号：</label>
					<span v-text="defect.col"></span>
				</li>
				<li>
					<label for>强度：</label>
					<span v-text="defect.energy"></span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { getDefectImageUrlByMd5 } from '@/network/requests/defect'
	export default {
		props: {
			defect: {
				type: Object,
			},
		},
		data() {
			return {
				/**
				 * 原始图片宽度
				 */
				imgWidth: 285,
				/**
				 * 新的图片宽度
				 */
				imgWidthNew: 190,
				/**
				 * 图片是否加载中
				 */
				loading: false,
			}
		},
		filters: {
			fil(val) {
				if (!val) return ''
				const value = val / 1000
				return `${value}米`
			},
		},
		computed: {
			/**
			 * 缩放系数
			 */
			imgWidthRatio() {
				return this.imgWidthNew / this.imgWidth
			},
		},
		watch: {
			defect(item) {},
		},
		methods: {
			/**
			 * 图片加载错误的蒙版图。
			 */
			nofindImg() {
				const img = event.srcElement
				img.src = require('@/assets/images/img.png')
				img.onerror = null //防止一直跳动
			},
			getDefectInfo(item) {
				var size_cx = item.size_cx * this.imgWidthRatio
				var size_cy = item.size_cy * this.imgWidthRatio
				var img_width = this.imgWidthNew
				var self = this

				this.loading = true

				getDefectImageUrlByMd5(item.md5, item.roll_id).then(imgdata => {
					var cxt = this.$refs.defectCanvas.getContext('2d')
					var img = new Image()

					img.src = imgdata
					img.onload = function() {
						cxt.drawImage(img, 0, 0, 200, 200)
						cxt.lineWidth = 1
						cxt.strokeStyle = '#f00'
						cxt.strokeRect(img_width / 2 - size_cx / 2, img_width / 2 - size_cy / 2, size_cx, size_cy)

						self.loading = false
					}
				})
			},
		},
		mounted() {
			this.getDefectInfo(this.defect)
		},
	}
</script>

<style lang="less" scoped>
	.defectInfo {
		padding: 0px 20px 5px;
		li {
			list-style: none;
			line-height: 20px;
			display: block;
			font-size: 12px;

			label {
				display: inline-block;
				color: #666;
			}
		}
	}
</style>
